(function () {
    'use strict';
    angular.module('mso.registration')
        .controller('RegisterCtrl', RegisterCtrl);

    RegisterCtrl.$inject = ['$scope', 'enums', 'referenceData', 'RegisterService', 'RegisterDataAccessService', 'RuleService', '$filter', '$location', '$exceptionHandler', '$timeout', '$translatePartialLoader', '$translate'];
    function RegisterCtrl($scope, enums, referenceData, RegisterService, RegisterDataAccessService, RuleService, $filter, $location, $exceptionHandler, $timeout, $translatePartialLoader, $translate) {

        $translatePartialLoader.addPart('languages');
        $translate.refresh();

        var vm = this;

        // functions exposed to the view
        vm.validateSortCode = validateSortCode;
        vm.validateRoleSelected = validateRoleSelected;
        vm.registerUser = registerUser;
        vm.findFirm = findFirm;
        vm.firmSelected = firmSelected;
        vm.firmSearchAgain = firmSearchAgain;
        vm.enterFirmManually = enterFirmManually;
        vm.preventPaste = preventPaste;
        vm.validateEmailAddress = validateEmailAddress;
        vm.getSelectedMortgageClubs = getSelectedMortgageClubs;
        vm.unSelectMortgageClub = unSelectMortgageClub;
        vm.clearFirmValidity = clearFirmValidity;
        vm.validateDateFormat = validateDateFormat;
        vm.validateIntermediaryOldEnough = validateIntermediaryOldEnough;
        vm.validateIntermediaryYoungEnough = validateIntermediaryYoungEnough;
        vm.haveSelectedFirm = haveSelectedFirm;
        vm.setTradingAddress = setTradingAddress;
        vm.tradingAddressSearchAgain = tradingAddressSearchAgain;
        vm.populateTradingAddressFromFirm = populateTradingAddressFromFirm;
        vm.needsFirmTradingAddresses = needsFirmTradingAddresses;
        vm.isRoleAvailable = isRoleAvailable;
        vm.onRoleSelectionChanged = onRoleSelectionChanged;
        vm.setAdminsCheckbox = setAdminsCheckbox;
        vm.telephoneOrMobileNumberRequired = telephoneOrMobileNumberRequired;
        vm.removeSelectedTradingAddress = removeSelectedTradingAddress;
        vm.removeSelectedPrincipalFirm = removeSelectedPrincipalFirm;
        
        // Initialise vm variables
        vm.referenceData = referenceData;
        vm.vs = referenceData.valuesets;
        vm.parameters = referenceData.parameters;
        vm.messages = referenceData.messages;
        vm.enums = enums;
        vm.selectedPrincipalFirm = null;
        vm.showSelectedPrincipalFirm = false;
        vm.showSelectedTradingAddress = false;
        vm.tradingNamePlaceholder = "Search by trading name...";
        vm.mortgageClubPlaceholder = "Search by mortgage club name...";
        vm.principleFirmPlaceholder = "Search by principle firm name or FCA number...";

        vm.user = {};
        vm.firm = {
            intermediaryType: enums.RDIntermediaryType.directlyAuthorised
        };

        vm.tradingAddress = {

        };

        vm.individualTitleCode = referenceData.valuesets.rdIndividualTitleCode;
        vm.nameTokens = ['2', '30', 'characters'];
        vm.roles = [];
        vm.resourceActions = [];
        var validRoleCombinations = [];
        vm.showValidation = false;
        $scope.showValidationToaster = false;

        //trading address search
        vm.findTradingAddressSelected = false;

        vm.tradingAddressSearchCriteria = "";
        vm.tradingAddressPage = 1;
        vm.tradingAddressPreviousPage = 1;
        vm.tradingAddressPageSize = 999;
        vm.tradingAddressPageCount = 0; // will be set by first call to api
        vm.tradingAddressItemCount = 0;

        //firm search
        vm.isNewUserFirmAllowed = (vm.parameters.p6089 || '').toLocaleLowerCase() === 'true';
        vm.principalFCARequired = (vm.parameters.p6640 || '').toLocaleLowerCase() === 'true';
        vm.principalFCADropDownRequired = (vm.parameters.p6641 || '').toLocaleLowerCase() === 'true';
        vm.findFirmSuccess = false;
        vm.findFirmClicked = false;
        vm.findFirmFcaNumber = '';
        vm.findFirmSelected = false;
        vm.firmIsManual = false;
        vm.firmSearchAtLeastOnce = false;
        vm.isFirmEmptyOnFindClick = false;

        vm.securityQuestion1 = { 'securityQuestion': undefined, 'securityAnswer': '' };
        vm.securityQuestion2 = { 'securityQuestion': undefined, 'securityAnswer': '' };
        vm.securityQuestion3 = { 'securityQuestion': undefined, 'securityAnswer': '' };
        vm.securityQuestions = [vm.securityQuestion1, vm.securityQuestion2, vm.securityQuestion3];
        vm.chosenSecurityQuestions = [];

        vm.bankAccountNumberValidationFailureId = 0;
        vm.bankSortCodeValidationFailureId = 0;
        var sortCodeRegex = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;

        vm.showCompletenessCheckValidation = true;

        vm.firmBankDetailError = undefined;

        vm.addressTypes = {
            "uk": 1,
            "bfpo": 2,
            "overseas": 3
        };

        vm.firmIdentifierPrefix = 'intermediaryRegistrationFirm';
        vm.firmAddressFlagsViewModel = {
            showAddressType: false,
            selected: false,
            showDisplayEdit: true,
            showEdit: false
        };

        vm.firmAddressViewModel = {
            addressType: vm.addressTypes.uk
        };

        vm.correspondenceIdentifierPrefix = 'intermediaryRegistrationCorrespondence';
        vm.correspondenceAddressFlagsViewModel = {
            showAddressType: false,
            selected: false,
            showDisplayEdit: true,
            showEdit: false
        };

        vm.correspondenceAddressViewModel = {
            addressType: vm.addressTypes.uk

        };

        vm.tradingAddressIdentifierPrefix = 'intermediaryRegistrationTradingAddress';
        vm.tradingAddressAddressFlagsViewModel = {
            showAddressType: false,
            selected: false,
            showDisplayEdit: true,
            showEdit: false
        };

        vm.tradingAddressAddressViewModel = {
            addressType: vm.addressTypes.uk
        };

        vm.bankIdentifierPrefix = 'intermediaryRegistrationBank';
        vm.bankAddressFlagsViewModel = {
            showAddressType: false,
            selected: false,
            showDisplayEdit: true,
            showEdit: false
        };

        vm.bankAddressViewModel = {
            addressType: vm.addressTypes.uk
        };

        vm.mortgageClubSearchBoxTitle = "Mortgage Club Search";
        vm.mortgageClubSearchBoxId = "mortgageClubSearch";
        vm.mortgageClubSearchBoxName = "mortgageClubSearchBox";
        vm.principalFirmSearchBoxName = "principalFirmSearchBox";
        vm.principalFirmFCASearchId ="principalFirmSearch";
        vm.bdmRelationshipApplicable = (vm.parameters.p6146 || '').toLocaleLowerCase() === 'true';
        vm.smsNotificationsApplicable = (vm.parameters.p6147 || '').toLocaleLowerCase() === 'true';
        vm.principalApplicable = (vm.parameters.p6153 || '').toLocaleLowerCase() === 'true';
        vm.tradingAddressSearchBoxTitle = "Trading Address Search";
        vm.tradingAddressSearchBoxId = "tradingAddressSearchBox";
        vm.tradingAddressSearchBoxName = "tradingAddressSearchBox";
        vm.captureFirmBankDetails = (vm.parameters.p6213 || '').toLocaleLowerCase() === 'true';
        vm.hasMarketingPreferenceEnabled = (vm.parameters.p6362 || '').toLocaleLowerCase() === 'true';
        vm.captureBdmDetails = (vm.parameters.p6521 || '').toLocaleLowerCase() === 'true';

        vm.user.isPrincipal = false;

        // Email address validation parameters. P6259 - pValidMSOEmailFormat, P6260 - pMinEmailAddressLength, P6261 - pMaxEmailAddressLength.
        vm.emailAddressRegEx = new RegExp(vm.parameters.p6259);
        vm.emailMinCharacterLength = vm.parameters.p6260;
        vm.emailMaxCharacterLength = vm.parameters.p6261;

        vm.telephoneNumberRegex = new RegExp(vm.parameters.p6304);
        vm.mobileNumberRegex = new RegExp(vm.parameters.p6305);
        vm.telephoneMaxCharacterLength = 30;

        vm.fcaNumberRegex = new RegExp(vm.parameters.p6653);
        vm.fcaNumberMinCharacterLength = 6;
        vm.fcaNumberMaxCharacterLength = 7;
        vm.maxFirmNameLength = 130;

        activate();

        function activate() {

            vm.bankServiceAvailable = RuleService.r5417BankServiceIntegrationAvailable(referenceData.parameters.p6079);
            $scope.$watch('vm.securityQuestion1', handleChosenSecurityChange, true);
            $scope.$watch('vm.securityQuestion2', handleChosenSecurityChange, true);
            $scope.$watch('vm.securityQuestion3', handleChosenSecurityChange, true);

            RegisterDataAccessService.getRoles().then(
                function (data) {
                    if (data) {
                        angular.forEach(data, function (role) {
                            vm.roles.push(role);
                        });
                    }
                },
                function (error) {
                    $exceptionHandler(error);
                }
            );

            RegisterDataAccessService.getValidRoleCombinations().then(
                function (data) {
                    if (data) {
                        angular.forEach(data, function (combination) {
                            var combo = combination.roles
                                .map(function (c) {
                                    return c.name.trim()
                                });
                            validRoleCombinations.push(combo);
                        });
                    }
                },
                function (error) {
                    $exceptionHandler(error);
                }
            );
            if (vm.principalFCADropDownRequired) {
                getPrincipalFirms(enums.RDIntermediaryType.directlyAuthorised);
            }
        }

        function telephoneOrMobileNumberRequired() {
            vm.contactNumberRequired = false;
            vm.receiveSMSNotification = false;
            //Either of the number is required.
            if ((vm.user.telephone === null || vm.user.telephone === undefined || vm.user.telephone === "") &&
                (vm.user.mobileNumber === null || vm.user.mobileNumber === undefined || vm.user.mobileNumber === "")) {

                vm.contactNumberRequired = true;
            }
            //receive SMS notification when mobile phone number is provided.
            else if (vm.user.mobileNumber !== null && vm.user.mobileNumber !== undefined && vm.user.mobileNumber !== "") {
                vm.receiveSMSNotification = true;
            } else {
                vm.user.smsNotifications = null;
            }
            return vm.contactNumberRequired || vm.receiveSMSNotification;
        }

        function resetMortgageClubExists() {
            if (vm.existsAsMortgageClub) {
                vm.existsAsMortgageClub = false;
            }
        }

        $scope.$watch('vm.selectedMortgageClub', function () {
            if (vm.selectedMortgageClub && vm.selectedMortgageClub.selected == true) {
                vm.mortgageClubsMissing = false;
            }
        }, true);

        $scope.$watch('vm.selectedTradingAddress', function () {
            if (vm.selectedTradingAddress && (typeof (vm.selectedTradingAddress) === "object")) {
                vm.setTradingAddress(vm.selectedTradingAddress);
                vm.tradingAddressMissing = false;
                vm.showSelectedTradingAddress = true;
            }
            else {
                vm.tradingAddressMissing = true;
                vm.showSelectedTradingAddress = false;
            }

        }, true);

        function validateSortCode(sortCode) {
            if (sortCode) {
                return sortCodeRegex.test(sortCode);
            }
            return true;
        }

        function preventPaste(e) {
            e.preventDefault();
            return false;
        }

        function validateEmailAddress(confirmEmailAddress) {
            if (confirmEmailAddress && vm.user.emailAddress) {
                return confirmEmailAddress.toUpperCase() === vm.user.emailAddress.toUpperCase();
            }
            return false;
        }

        // Validate that at least one of the roles has been selected
        function validateRoleSelected() {
            var selectedRoles = vm.roles.filter(function (role) {
                return role.checked;
            });
            return selectedRoles.length > 0;
        }

        function handleChosenSecurityChange(newValue, oldValue) {
            // Update vm.chosenSecurityQuestions
            if (angular.isDefined(oldValue) && angular.isDefined(oldValue.securityQuestion)) {
                var index = vm.chosenSecurityQuestions.indexOf(oldValue.securityQuestion);
                if (index !== -1) {
                    // Old value found in chosen questions. Remove it.
                    vm.chosenSecurityQuestions.splice(index, 1);
                }
                if (angular.isDefined(newValue) && angular.isDefined(newValue.securityQuestion)) {
                    // Add the new choice to the chosen questions
                    vm.chosenSecurityQuestions.push(newValue.securityQuestion);
                }
            }
            else if (angular.isDefined(newValue) && angular.isDefined(newValue.securityQuestion)) {
                // Add the new choice to the chosen questions
                vm.chosenSecurityQuestions.push(newValue.securityQuestion);
            }

            // Figure out whether security answers are unique
            syncSecurityAnswers();
        }

        function syncSecurityAnswers() {
            // Reset validity before scanning each question/answer set
            $scope.userForm.securityQuestionFormMain.$setValidity('answerIsNotUnique', true);

            checkSecurityAnswerForUniqueness(vm.securityQuestion1);
            checkSecurityAnswerForUniqueness(vm.securityQuestion2);
            checkSecurityAnswerForUniqueness(vm.securityQuestion3);
        }

        function checkSecurityAnswerForUniqueness(securityQuestion) {
            securityQuestion.isSecurityAnswerUnique = isSecurityAnswerUnique(securityQuestion.securityAnswer);
            if (!securityQuestion.isSecurityAnswerUnique) {
                // Answer is not unique. Invalidate the main form so that it won't submit.
                $scope.userForm.securityQuestionFormMain.$setValidity('answerIsNotUnique', false);
            }
        }

        function isSecurityAnswerUnique(securityAnswer) {
            // Treat empty values as unique
            if (!angular.isDefined(securityAnswer) || securityAnswer === "") {
                return true;
            }

            var matchingAnswers = vm.securityQuestions.filter(function (item) {
                return item.securityAnswer === securityAnswer;
            });

            // If the answer is unique it should be the only instance in the collection.
            return matchingAnswers.length === 1;
        }

        function registerUser(form) {
            telephoneOrMobileNumberRequired();
            form.emailAddress.$setValidity("duplicate", true);

            RegisterService.prepareUserRegistration(form, vm).then(function (user) {
                // All good - go ahead and register
                RegisterDataAccessService.register(user)
                    .then(function (data) {
                        $location.path('/register-success');
                    }, function (error) {

                        if (error.status == '400') {
                            if (error.data.message.toUpperCase() === "EMAIL ALREADY REGISTERED") {
                                form.emailAddress.$setValidity("duplicate", false);
                            }

                            vm.showValidation = true;
                            $scope.showValidationToaster = true;
                            form.$invalid = true;
                            vm.errorMessage = error.data.message;
                        }
                        else {
                            $exceptionHandler(error);
                        }
                    });
            }, function (error) {
                if (error) {
                    if (error.status == '400') {
                        vm.showValidation = true;
                        $scope.showValidationToaster = true;
                    }
                    else {
                        $exceptionHandler(error);
                    }
                }
                else {
                    vm.showValidation = true;
                    $scope.showValidationToaster = true;
                }
            });
        }

        function firmSelected() {
            vm.findFirmClicked = false;
            vm.tradingAddressPage = 1;

            if (!vm.firm.isPending) {
                getAllTradingAddresssesForFirm(vm.firm.id);
            }
        }


        function firmSearchAgain() {
            vm.findFirmSelected = false;
            vm.findFirmClicked = false;
            vm.findFirmSuccess = false;
            if (vm.firmIsManual) {
                vm.firmIsManual = false;
            }
            vm.findTradingAddressSelected = false;
            delete vm.tradingAddress;
            delete vm.selectedTradingAddress;

        }

        function tradingAddressSearchAgain() {
            vm.findTradingAddressSelected = false;
        }

        function enterFirmManually() {
            vm.firmIsManual = !vm.firmIsManual;
            if (vm.firmIsManual) {
                delete vm.firm.firmName;
                vm.firm.intermediaryType = enums.RDIntermediaryType.directlyAuthorised; //default
                vm.firm.address = {};
                delete vm.firmAddressViewModel.buildingNo;
                delete vm.firmAddressViewModel.buildingName;
                delete vm.firmAddressViewModel.flat;
                delete vm.firmAddressViewModel.street;
                delete vm.firmAddressViewModel.district;
                delete vm.firmAddressViewModel.town;
                delete vm.firmAddressViewModel.county;
                delete vm.firmAddressViewModel.postcode;
                vm.firm.bankDetails = {};
                delete vm.firm.paymentRoute;
                vm.findFirmSelected = false;
                vm.findFirmClicked = false;
                vm.findFirmSuccess = false;
                tradingAddressSearchAgain();
                delete vm.tradingAddress;
                if (!vm.allMortgageClubs) {
                    RegisterDataAccessService.getAllMortgageClubs()
                        .then(function (data) {
                            vm.allMortgageClubs = data;
                        }, function (error) {
                            $exceptionHandler(error);
                        });
                } else {
                    for (var i = 0; i < vm.allMortgageClubs.length; i++) {
                        vm.allMortgageClubs[i].selected = false;
                    }
                }

                var element = document.getElementById("firmFcaNumber");
                if (element) {
                    $timeout(function () {
                        element.focus();
                    }, 0);
                }
            }
        }

        function needsFirmTradingAddresses() {
            return vm.findFirmSelected && (vm.allTradingAddresses.length === 0);
        }

        function getAllTradingAddresssesForFirm(firmId) {
            RegisterDataAccessService.getAllTradingAddressesForFirm(firmId).then(function (data) {
                vm.findFirmSelected = true;
                vm.tradingAddresses = data.tradingAddresses;
                angular.forEach(vm.tradingAddresses, function (ta) {
                    ta.address.addressType = vm.addressTypes.uk;
                });
                vm.tradingAddressItemCount = data.itemCount;
                vm.tradingAddressPageCount = Math.ceil(vm.tradingAddressItemCount / vm.tradingAddressPageSize) * 10 / 10;
                // if only one trading address, then select that, no point showing search controls
                vm.allTradingAddresses = angular.copy(vm.tradingAddresses, vm.allTradingAddresses);
                vm.allTradingAddresses = $filter('orderBy')(vm.allTradingAddresses, 'name');

                vm.needsFirmTradingAddressError = needsFirmTradingAddresses();

                if (vm.tradingAddresses.length === 1) {
                    vm.tradingAddress = vm.tradingAddresses[0];
                    vm.findTradingAddressSelected = true;
                    vm.selectedTradingAddress = vm.tradingAddress;
                }
            },
                function () {
                    vm.showValidation = true;
                    vm.showValidationToaster = true;
                });
        }

        function getTradingAddressForPending(tradingData) {
            vm.tradingAddress = tradingData.tradingAddress;
            vm.tradingAddress.addressType = vm.addressTypes.uk;
            vm.tradingAddressItemCount = 1;
            vm.tradingAddressPageCount = 1;
            vm.allTradingAddresses = vm.tradingAddress;

            vm.needsFirmTradingAddressError = needsFirmTradingAddresses();
            vm.findTradingAddressSelected = true;
            vm.selectedTradingAddress = vm.tradingAddress;
        }

        function populateTradingAddressFromFirm() {
            //{Note that any data in BDM is not touched
            // open trading address address editor as if for manual edit
            vm.tradingAddressAddressFlagsViewModel.showEdit = true;
            vm.tradingAddressAddressFlagsViewModel.showSearch = false;

            if ((vm.tradingAddress === undefined) || (vm.tradingAddress === null)) {
                vm.tradingAddress = {}
            }
            vm.tradingAddress.address = {};
            vm.tradingAddress.name = vm.firm.firmName;
            for (var attrname in vm.firmAddressViewModel) {
                vm.tradingAddressAddressViewModel[attrname] = vm.firmAddressViewModel[attrname];
            }
        }

        function findFirm(fcaNumber) {
            if (fcaNumber != undefined && (fcaNumber.length === vm.fcaNumberMinCharacterLength || fcaNumber.length === vm.fcaNumberMaxCharacterLength)) {
                vm.firmSearchAtLeastOnce = true;
                vm.findFirmFcaNumber = fcaNumber;
                RegisterDataAccessService.verifyFirm(fcaNumber)
                    .then(function (data) {
                        vm.findFirmClicked = true;
                        vm.firm.id = data.id;
                        vm.firm.firmName = data.name;
                        vm.firm.intermediaryType = data.firmType;
                        vm.firm.address = data.address;
                        vm.firm.paymentRoute = data.paymentRoutes;
                        vm.firm.networkFcaNumber = data.networkFcaNumber;
                        vm.firm.isPending = data.isPending
                        if (vm.firm.isPending &&
                            data.tradingAddress != null) {
                            getTradingAddressForPending(data);
                        }
                        if (vm.firm.networkFcaNumber == undefined && data.existingNetwork != null) {
                            vm.firm.networkFcaNumber = data.existingNetwork.registrationNumber;
                        }
                        if (data.bankDetails) {
                            vm.firm.bankDetails = {
                                accountNumber: data.bankDetails.accountNumber,
                                sortCode: data.bankDetails.sortCode,
                                accountHolder: data.bankDetails.accountHolder,
                                bankName: data.bankDetails.bankName
                            };
                            vm.bankAddressViewModel.buildingNo = data.bankDetails.address.buildingNumber;
                            vm.bankAddressViewModel.buildingName = data.bankDetails.address.buildingName;
                            vm.bankAddressViewModel.flat = data.bankDetails.address.flat;
                            vm.bankAddressViewModel.street = data.bankDetails.address.street;
                            vm.bankAddressViewModel.district = data.bankDetails.address.district;
                            vm.bankAddressViewModel.town = data.bankDetails.address.town;
                            vm.bankAddressViewModel.county = data.bankDetails.address.county;
                            vm.bankAddressViewModel.postcode = data.bankDetails.address.postcode;
                        }
                        if (data.mortgageClubs) {
                            vm.firm.mortgageClubs = data.mortgageClubs;
                        }
                        vm.firm.isSentNotifications = data.isSentNotifications;
                        delete vm.firmAddressViewModel.buildingNo;
                        delete vm.firmAddressViewModel.buildingName;
                        delete vm.firmAddressViewModel.flat;
                        delete vm.firmAddressViewModel.street;
                        delete vm.firmAddressViewModel.district;
                        delete vm.firmAddressViewModel.town;
                        delete vm.firmAddressViewModel.county;
                        delete vm.firmAddressViewModel.postcode;
                        for (var attrname in vm.firm.address) {
                            vm.firmAddressViewModel[attrname] = vm.firm.address[attrname];
                        }
                        vm.findFirmSuccess = true;
                    }, function (error) {
                        if (error.status == 400 || error.status == 404) {
                            vm.findFirmClicked = true;
                            vm.findFirmSuccess = false;
                        }
                        else {
                            $exceptionHandler(error);
                        }
                    });
            }
            else {
                vm.isFirmEmptyOnFindClick = true;
                vm.findFirmSuccess = false;
                vm.findFirmClicked = false;
            }
        }

        function getPrincipalFirms(firmType) {
            RegisterDataAccessService.getPrincipalFirms(firmType).then(function (data) {
                var firms = data
                angular.forEach(firms, function (value) {
                    value.name = value.name + " (" + value.fcaNumber + ")";
                });

                vm.principalFirms = firms;
            });
        }

        function removeSelectedPrincipalFirm() {
            vm.showSelectedPrincipalFirm = false;
            if (vm.principalFCARequired) {
                vm.principalFirmMissing = true;
            }
            vm.selectedPrincipalFirm = null;
        }

        $scope.$watch('vm.selectedPrincipalFirm', function () {
            if (vm.selectedPrincipalFirm != null && vm.selectedPrincipalFirm.fcaNumber != "" && typeof vm.selectedPrincipalFirm === "object") {
                vm.principalFirmMissing = false;
                vm.showSelectedPrincipalFirm = true;
            }
        });

        function getSelectedMortgageClubs() {
            return RegisterService.getSelectedMortgageClubs(vm);
        }

        function unSelectMortgageClub(mc) {
            mc.selected = false;
            var selectedMortgageClubs = RegisterService.getSelectedMortgageClubs(vm);
            if (selectedMortgageClubs === null || selectedMortgageClubs.length === 0) {
                vm.mortgageClubsMissing = true;
                vm.selectedMortgageClub = null;
            }
        }

        function removeSelectedTradingAddress() {
            vm.selectedTradingAddress = null;
        }

        function clearFirmValidity(form) {
            form.firmFcaNumber.$setValidity('duplicatefirm', true);
            vm.isFirmEmptyOnFindClick = false;
        }

        function validateDateFormat(dateToValidate) {
            if (dateToValidate) {
                return moment(dateToValidate, 'L', true).isValid();
            }
            return true;
        }

        // Check if intermediary is old enough to register
        function validateIntermediaryOldEnough(dateToValidate) {
            var oldEnough = false;
            if (dateToValidate) {
                oldEnough = RuleService.r5838IntermediaryUserOlderMinAge(
                    moment(dateToValidate, 'DD/MM/YYYY'),
                    vm.parameters.p6148);
            }
            return oldEnough;
        }

        // Check if intermediary is old enough to register
        function validateIntermediaryYoungEnough(dateToValidate) {
            var youngEnough = false;
            if (dateToValidate) {
                youngEnough = RuleService.r5847IntermediaryUserYoungerMaxAge(
                    moment(dateToValidate, 'DD/MM/YYYY'),
                    vm.parameters.p6151);
            }
            return youngEnough;
        }

        function haveSelectedFirm() {
            vm.firmSelected();
        }

        function setTradingAddress(tradingAddress) {
            vm.tradingAddress = angular.fromJson(tradingAddress);
            vm.findTradingAddressSelected = true;
        }

        // Checks whether the supplied role is available given the existing
        // selection of roles
        function isRoleAvailable(roleName) {
            var selectedRoles = vm.roles.filter(function (role) {
                return role.checked;
            });

            // Any selected role should not be disabled
            if (selectedRoles.filter(function (role) {
                return role.name === roleName;
            }).length > 0) {
                return true;
            }
            // If no role selected yet, all are available
            if (selectedRoles.length === 0) {
                return true;
            }

            // Set up a test combination of roles.  Start with the existing role(s)
            var testCombination = angular.copy(selectedRoles).map(function (r) { return r.name });

            // Add in the candidate role
            testCombination.push(roleName);

            // Now check that the test combination of roles matches a valid combination
            var isValid = false;
            angular.forEach(validRoleCombinations, function (validCombination) {
                if (validCombination.sort().join(',') === testCombination.sort().join(',')) {
                    isValid = true;
                }
            });

            return isValid;
        }

        function onRoleSelectionChanged() {
            var selectedRoles = vm.roles.filter(function (role) {
                return role.checked;
            }).map(function (r) {
                return r.name;
            });

            RegisterDataAccessService.checkResourceAction(selectedRoles, 'IntermediaryCases', 'AdministerOwnCases')
                .then(function (data) {
                    vm.roleAcceptableForFirmPrincipal = data.result;
                    vm.roleAcceptableForAdminNotifications = data.result;
                }, function (error) {
                    $exceptionHandler(error);
                });
        }

        function setAdminsCheckbox(vm) {
            return vm.roleAcceptableForAdminNotifications && !vm.firm.isSentNotifications && vm.parameters.p6482 === 'True' &&
                (
                    (vm.findFirmSelected || vm.firmIsManual) ||
                    (vm.findFirmSuccess && vm.findFirmClicked && !vm.firmIsManual) ||
                    vm.firmIsManual
                );
        }

        $scope.OpenNewPage = function (target, windowName) {
            window.open(target, windowName, "width=800,height=640,scrollbars,resizable", false);
        };

        $scope.onDobKeydown = function onDobKeydown(event) {
            if (event.code === "Space") {
                event.preventDefault();
            }
        }
    }
})();
